import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { UserSidePathUrl } from '../../../../common/config';
// import * as configuration from '../../../../utils/configuration';
import dateformat from 'dateformat';
import { FormProvider, useForm } from 'react-hook-form';
//--- Material Table
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';

import FooterPagination from '../../../../components/footer-pagination/pagination';

import {
    APIUrlDefault,
    DomainUserSide,
} from '../../../../utils/configuration';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    TextField
} from '@material-ui/core';

//--- Material Icon
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Restore';

// import AssignmentIcon from '@material-ui/icons/Assignment';
// import AddCommentIcon from '@material-ui/icons/AddComment';
//--- Material Control
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { convertWallet } from '../../../../utils/helpers/convertWallet';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    tableContainer: {
        maxHeight: window.outerHeight - 365,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    pointer: { cursor: 'pointer' },
}));

const headCells = [
    { id: 'name', hideSortIcon: true, label: 'Tên' },
    { id: 'title', hideSortIcon: false, label: 'Tiêu đề' },
    { id: 'vrProjectName', hideSortIcon: false, label: 'Thuộc dự án' },
    { id: 'isViewDefault', hideSortIcon: false, label: 'Mặc định' },
    { id: 'connectionIds', hideSortIcon: false, label: 'Liên kết' },
    { id: 'createdDate', hideSortIcon: true, label: 'Ngày tạo' },
    { id: 'createdBy', hideSortIcon: true, label: 'Người tạo' },
    { id: 'modifiedDate', hideSortIcon: true, label: 'Ngày sửa' },
    { id: 'modifiedBy', hideSortIcon: true, label: 'Người sửa' },
    { id: 'actions', hideSortIcon: true, label: '' },
];

const ListEdition = (props) => {
    const { listModel, deleteAction, editAction, pagination } = props;
    return (
        <>
            {listModel.length > 0 ? (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {headCells.map(item => (
                                    <TableCell key={item.id}>
                                        {item.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listModel.map(item => (
                                <TableRow key={item.id}>
                                    <TableCell>
                                        {item.name}
                                    </TableCell>
                                    <TableCell>
                                        {item.title}
                                    </TableCell>
                                    <TableCell>
                                        {item.vrProjectName}
                                    </TableCell>
                                    <TableCell>
                                        {item.isViewDefault ? 'true' : 'false'}
                                    </TableCell>
                                    <TableCell>
                                        {item.connectionName.map(x => x.name).join(', ')}
                                    </TableCell>
                                    <TableCell>
                                        {dateformat(item.created_date, 'dd/mm/yyyy')}
                                    </TableCell>
                                    <TableCell>
                                        {item.created_by}
                                    </TableCell>
                                    <TableCell>
                                        {dateformat(item.modified_date, 'dd/mm/yyyy')}
                                    </TableCell>
                                    <TableCell>
                                        {item.modified_by}
                                    </TableCell>
                                    <TableCell align='right' className='text-nowrap'>
                                        <Tooltip title='Sửa'>
                                            <IconButton
                                                aria-label='edit'
                                                onClick={() => editAction(item)}>
                                                <EditIcon className='text-primary' />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title='Xóa'>
                                            <IconButton
                                                aria-label='delete'
                                                onClick={() => deleteAction(item.id)}>
                                                <DeleteIcon className='text-danger' />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <>chưa tạo</>
            )}
            {pagination.totalItemCount && pagination.totalItemCount > 0 ? (
                <FooterPagination
                    showFirstLastButton
                    currentPage={pagination.pageIndex}
                    totalPage={pagination.pageCount}
                    totalItemCount={pagination.totalItemCount}
                    pageLimit={pagination.pageSize}
                />
            ) : (
                ''
            )}

        </>
    )
}

export default ListEdition;